import Immutable from 'immutable';
import { all, call, fork, put, takeEvery, select } from 'redux-saga/effects';

// action creators
import { doneIndicator, success } from 'store/actions/httpActions';

// selector
import getCurrentGroupId from 'store/selectors/getCurrentGroupId';

// api
import client from 'sources/api';

// constants
import { NOTE_UPDATE_REQUEST, NOTE_UPDATE } from 'store/constants/noteTypes';

// schemas
import { noteSchema } from 'store/schemas/noteSchema';

// helpers
import httpSaga from 'store/sagas/httpSaga';
import getResponsePayload from 'helpers/getResponsePayload';

const WATCH_TYPE = NOTE_UPDATE_REQUEST;
const TYPE = NOTE_UPDATE;

export function* updateNote(action: any) {
  const {
    payload: { id, body, tagIds, formName },
  } = action;

  const currentGroupId = yield select(getCurrentGroupId);

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  const response = yield* httpSaga(
    TYPE,
    call(client.patch, `/notes/${id}?group_id=${currentGroupId}`, {
      body,
      tag_ids: tagIds,
    }),
    {
      dispatchSuccess: false,
      formName,
      schema: noteSchema,
    }
  );

  // format and normalize the response
  const payload = getResponsePayload(response, noteSchema);

  yield put(success(TYPE, Immutable.fromJS(payload), id));
  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, updateNote);
}

export default function* root() {
  yield all([fork(watch)]);
}
